module.exports = __webpack_public_path__ + "assets/e0132fd4c4cbabd6584616a428aefa80.png";